module.exports = __webpack_public_path__ + "img/79-fb1e14.png";